import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Footer = ({ data }) => {
    const { content, nav } = data;

    return (
        <div className={styles.footer}>
            <div className={styles.links}>
                {/* <a href="#">凤凰新媒体介绍</a><span className={styles.divider}>|</span>
              <a href="#">投资者关系 Investor Relations</a><span className={styles.divider}>|</span>
              <a href="#">广告服务</a><span className={styles.divider}>|</span>
              <a href="#">诚征英才</a><span className={styles.divider}>|</span>
              <a href="#">保护隐私权</a><span className={styles.divider}>|</span>
              <a href="#">免责条款</a><span className={styles.divider}>|</span>
              <a href="#">意见反馈</a><span className={styles.divider}>|</span>
              <a href="#">凤凰卫视介绍</a> */}

                {nav.map((item, index) => (
                    <>
                        <a href={item.url}>{item.title}</a>
                        {index < nav.length - 1 && <span className={styles.divider}>|</span>}
                    </>
                ))}
            </div>
            <div>
                <span className={styles.span}>{content.text0}</span>
                <span className={styles.span}>{content.text1}</span>
                {content.text2}
            </div>
        </div>
    );
};

Footer.propTypes = {
    data: PropTypes.object,
};

export default errorBoundary(Footer);
